import { debounce } from "../../utils/debounce.util"

export const setupScrollFader = (): void => {
  const scrollIndicator = document.querySelector<HTMLElement>("#scroll-indicator")
  if (!scrollIndicator) {
    return
  }

  const debounceDelay = 50

  window.addEventListener(
    "scroll",
    debounce(() => fadeIndicator(scrollIndicator), debounceDelay)
  )
  window.addEventListener(
    "resize",
    debounce(() => fadeIndicator(scrollIndicator), debounceDelay)
  )
  fadeIndicator(scrollIndicator) // Initial call to set the position
}

const fadeIndicator = (scrollIndicator: HTMLElement): void => {
  if (window.scrollY * 4 > scrollIndicator.getBoundingClientRect().top) {
    scrollIndicator.classList.add("faded")
  } else {
    scrollIndicator.classList.remove("faded")
  }
}
